import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function StructuralTypeModal({
  createStructuralTypeData,
  getList,
  history,
  getStructuralTypeList,
  type,
  updateStructuralTypeData,
  updateList,
  id,
  buildingKindId,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  ordinanceRevisionId
}) {

  const [formData, setFormData] = useState({
    type: '',
    name: '',
    description: '',
    unit_construction_cost: '',
    ordinance_revision_id: ordinanceRevisionId,
    is_active: 0,
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    unit_construction_cost: 'required',
    ordinance_revision_id: 'required',
  });

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? isChecked : e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createStructuralTypeData(buildingKindId, formData, () => {
        setModal({ isOpen: false });
        getList();
        history.push(`/rpt/building/settings/building-kinds/${buildingKindId}`);
        getStructuralTypeList(buildingKindId, { ordinance_revision_id: ordinanceRevisionId });
      });
    }

    if (type === 'EDIT') {
      updateStructuralTypeData(buildingKindId, id, formData, () => {
        setModal({ isOpen: false });
        getList();
        history.push(`/rpt/building/settings/building-kinds/${buildingKindId}`);
        getStructuralTypeList(buildingKindId, { ordinance_revision_id: ordinanceRevisionId });
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    setFormData(updateList);
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  useEffect(() => {
    if (_.isEmpty(ordinanceRevisionList)) getOrdinanceRevisionList();
  }, []);

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        name: data.attributes.name,
        year_from: data.attributes.year_from,
        year_to: data.attributes.year_to,
        value: data.id,
      });
    });
    return newList;
  };

  const onRenderOption = (item) => {
    return (
      <table>
        <tbody>
          <tr>
            <td style={{ width: 250 }}>{item.name}</td>
            <td className="text-right" style={{ width: 100 }}>
              {item.year_from} - {item.year_to}{' '}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const handleOrdinanceSelect = (e) => {
    setFormData({
      ...formData,
      ordinance_revision_id: e.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Name{' '}
              {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Rate{' '}
              {validateForm.renderMessage('unit_construction_cost')}
            </label>
            <input
              className="form-control"
              type="number"
              name="unit_construction_cost"
              onChange={onChange}
              value={_.get(formData, 'unit_construction_cost')}
            />
          </div>
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Ordinance Revision{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <Select
              options={createDropdown(ordinanceRevisionList)}
              styles={customStyle}
              placeholder="Select Ordinance"
              value={
                createDropdown(ordinanceRevisionList).filter(
                  (item) =>
                    +_.get(formData, 'ordinance_revision_id') ===
                    +_.get(item, 'value')
                ) || ''
              }
              isDisabled
              onChange={(e) => {
                handleOrdinanceSelect(e);
              }}
              formatOptionLabel={onRenderOption}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <hr className="below-hr" />
        <div className="d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-3"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

StructuralTypeModal.defaultProps = {
  type: '',
  updateList: {},
  id: '',
  buildingKindId: '',
  ordinanceRevisionId: null,
};

StructuralTypeModal.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  buildingKindId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getList: PropTypes.instanceOf(Function).isRequired,
  createStructuralTypeData: PropTypes.instanceOf(Function).isRequired,
  updateStructuralTypeData: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getStructuralTypeList: PropTypes.instanceOf(Function).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number,
};

const mapStateToProps = ({ api },) => ({
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(StructuralTypeModal);
